import React from 'react';
import { dt } from "src/utils/documentsI18n";
import './FactoringNotice.css';

const CreditDebitNotice = ({ refDocumentCode, refDocumentId, downloadUrl }) => {
  return (
    <div className="factoring-notice">
      <div className="factoring-notice__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className="factoring-notice__content">
        <div className="factoring-notice__text">
          {dt('detail.referencesDocument', {
            code: refDocumentCode || dt('common.document'),
            id: refDocumentId,
          })}
        </div>
        {downloadUrl && (
          <div className="factoring-notice__link">
            <a 
              href={downloadUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="factoring-notice__link-text"
            >
              {dt('common.viewBacking')}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreditDebitNotice; 